// src/utils/formatTitle.js

const formatTitle = (title) => {
    const formattedTitles = {
      analise_magico_coringa: 'Análise Mágico Coringa',
      analise_mult3_perf_cm: 'Análise Multi 3 Perf CM',
      analise_fibonacci_cm: 'Análise Fibonacci CM',
      analise_primo_cm: 'Análise Primo CM',
      analise_linhas: 'Análise Linhas',
      analise_colunas: 'Análise Colunas',
      analise_linhas_impar: 'Análise Linhas Ímpares',
      analise_linhas_pares: 'Análise Linhas Pares',
      analise_multiplo3: 'Análise Múltiplos de 3',
      analise_fibonacci: 'Análise Fibonacci',
      analise_primos: 'Análise Primos',
      analise_triangular: 'Análise Triangular',
      analise_perfeito: 'Análise Perfeito',
      analise_repetidos: 'Análise Repetidos',
      analise_sequencia: 'Análise Sequência',
      analise_asteriscos: 'Análise Asteriscos',
      analise_inicio: 'Análise Início',
      analise_final: 'Análise Final',
      analise_magico: 'Análise Mágico',
      analise_soma: 'Análise Soma',
      analise_coringa: 'Análise Coringa',
      analise_misticos: 'Análise Místicos',
      analise_molduras: 'Análise Molduras',
      analise_par_impar: 'Análise Par e Ímpar',
      analise_soma_CC: 'Análise Soma CC',
      analise_prioCm_CC: 'Análise Primo CM CC',
      analise_fiboCm_CC: 'Análise Fibonacci CM CC',
      analise_mix3xPerf_CC: 'Análise Multi 3xPerf CM CC',
      analise_magicoCoringa_CC: 'Análise Mágico Coringa CC',
      analise_asteriscos_CC: 'Análise Asteriscos CC',
      analise_triangulares_CC: 'Análise Triangulares CC',
      analise_numerosPerfeitos_CC: 'Análise Perfeito CC',
      analise_coringa_CC: 'Análise Coringa CC',
      analise_fibonacci_cc: 'Análise Fibonacci CC',
      analise_multiplo3_CC: 'Análise Múltiplos de 3 CC',
      analise_primos_CC: 'Análise Primo CC',
      analise_magicos_CC: 'Análise Mágico CC',
      analise_par_impar_CC: 'Análise Par e Ímpar CC',
      analise_molduras_CC: 'Análise Molduras CC',
    };
  
    return formattedTitles[title] || title.replace(/_/g, ' ').toUpperCase();
  };
  
  export { formatTitle };
  